import { CreateModal as GenericCreateModal } from '@admin/organisms/CreateModal';
import { AdminRoute, getRoutePath } from '@admin/routing';
import { useArtikelThemeConfig } from '@admin/templates/artikel/Artikel.config';
import { type NewsCategory, type NewsItemActionCreate, NewsStatus } from '@common/clients/api';
import { useContextData } from '@common/useContextData';
import { useUserContext } from '@common/useUserContext/UserContextProvider';

import { createNews } from '../helpers/createNews';
import { formFields } from '../helpers/formFields';
import { type ArticleItem, type NewsActionCreateItem } from '../types';

interface Props {
    categories: NewsCategory[];
    onSuccess: () => void;
    __translationKey: string;
}

export const CreateModal = ({ categories, onSuccess, __translationKey }: Props) => {
    const contextData = useContextData();
    const userContext = useUserContext();
    const themeConfig = useArtikelThemeConfig();

    const getCategoryID = (slug: string) => {
        const category = categories.find((catobj: NewsCategory) => catobj.slug === slug);
        return category?.id;
    };

    const submit = async (data: NewsActionCreateItem): Promise<void> => {
        const requestBody: NewsItemActionCreate = {
            newsTitle: data.newsTitle,
            categoryID: getCategoryID(data.category),
            commentCount: 0,
            status: NewsStatus.DRAFT,
        };

        return await createNews({
            contextData,
            userContext,
            requestBody,
        }).then((response) => {
            if (response.newsID) {
                const activeParam = themeConfig.defaultStatus === NewsStatus.PUBLISHED ? 1 : 0;
                window.location.href = `${getRoutePath(
                    response?.category?.isMedia ? AdminRoute.Media : AdminRoute.Article,
                )}/${response?.newsID}?active=${activeParam}`;
            }
        });
    };

    return (
        <GenericCreateModal<ArticleItem, NewsActionCreateItem>
            onSuccess={onSuccess}
            formFields={formFields(categories)}
            submit={submit}
            __translationKey={__translationKey}
        />
    );
};
